import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import React from 'react'

import { IIsInconsistencyPayload } from '../models'

import { FieldWithDisabledWarnings } from './ui/fieldWithDisabledWarnings/FieldWithDisabledWarnings'
import { FieldWithEnabledWarnings } from './ui/fieldWithEnabledWarnings/FieldWithEnabledWarnings'

interface IProps {
  keyValue: TRevenueSnapshotKeys
  isInconsistency: (args: IIsInconsistencyPayload) => boolean
  yearField: keyof IRevenue
  quarterFields: (keyof IRevenue)[]
  value: string | number | undefined | null
  isDisabled?: boolean
}

export const RenderYearResultColumn = ({
  keyValue,
  isInconsistency,
  yearField,
  value,
  quarterFields,
  isDisabled,
}: IProps) => {
  if (isDisabled) {
    return <FieldWithDisabledWarnings keyValue={keyValue} value={value} />
  }

  return (
    <FieldWithEnabledWarnings
      keyValue={keyValue}
      quarterFields={quarterFields}
      value={value}
      yearField={yearField}
      isInconsistency={isInconsistency}
    />
  )
}
